<template>
  <IconWrapper name="copy" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.1982 4.53158C17.8972 2.30458 14.2912 2.30458 11.9902 4.53158C11.5932 4.91558 11.5822 5.54858 11.9662 5.94558C12.3512 6.34358 12.9832 6.35258 13.3802 5.96858C14.9032 4.49658 17.2872 4.49858 18.8082 5.96958C19.5582 6.69358 19.9822 7.66558 20.0002 8.70658C20.0182 9.74758 19.6292 10.7346 18.9162 11.4726L16.6562 13.7316C16.5282 13.8636 16.3892 13.9796 16.2412 14.0906C15.4082 14.7156 14.3852 14.9756 13.3522 14.8316C12.3172 14.6826 11.4022 14.1396 10.7752 13.3026C10.4442 12.8596 9.8182 12.7676 9.3752 13.0996C8.9332 13.4306 8.8432 14.0566 9.1742 14.4996C10.1212 15.7656 11.5042 16.5876 13.0692 16.8106C13.3522 16.8516 13.6352 16.8716 13.9162 16.8716C15.1832 16.8716 16.4102 16.4656 17.4392 15.6916C17.6862 15.5086 17.8982 15.3236 18.0802 15.1366L20.3422 12.8746C21.4382 11.7396 22.0272 10.2476 21.9992 8.67258C21.9722 7.09558 21.3322 5.62558 20.1982 4.53158Z"
        fill="#1B1B1E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6199 18.0321C9.09789 19.5051 6.71389 19.5031 5.19189 18.0311C4.44089 17.3061 4.01689 16.3321 3.99989 15.2871C3.98289 14.2461 4.37189 13.2621 5.08589 12.5271L7.32289 10.2801C7.46589 10.1411 7.62089 10.0111 7.75689 9.90206C9.47989 8.61606 11.9329 8.97006 13.2259 10.6911C13.5579 11.1341 14.1829 11.2211 14.6259 10.8901C15.0679 10.5581 15.1569 9.93106 14.8259 9.49006C12.8709 6.88806 9.16289 6.35406 6.53289 8.32006C6.32089 8.49106 6.11989 8.66106 5.91889 8.85506L3.65989 11.1251C2.56389 12.2541 1.97389 13.7431 2.00089 15.3201C2.02689 16.9001 2.66689 18.3741 3.80289 19.4691C4.95289 20.5831 6.42889 21.1391 7.90589 21.1391C9.38289 21.1391 10.8599 20.5831 12.0109 19.4691C12.4079 19.0861 12.4179 18.4531 12.0339 18.0551C11.6499 17.6571 11.0169 17.6481 10.6199 18.0321Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
